import { render, staticRenderFns } from "./FileCSVSolid.vue?vue&type=template&id=5982eab4&"
import script from "./FileCSVSolid.vue?vue&type=script&lang=js&"
export * from "./FileCSVSolid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports